// FieldDisplayInDefaultListsField.jsx

import React from 'react';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * FieldDisplayInDefaultListsField
 *
 * Toggle for showing this field on collection lists that have no field list of their own.
 *
 * @param {boolean} displayInDefaultLists - Whether the field appears on default lists.
 * @param {function} onDisplayInDefaultListsChange - Called with the next boolean value.
 *
 * @returns {ReactNode} The rendered control.
 */
const FieldDisplayInDefaultListsField = ({
  displayInDefaultLists,
  onDisplayInDefaultListsChange,
}) => (

  <ModalField>

    <ModalLabel label="Default Lists" />
    <ModalHint hint="When enabled, this field appears on collection lists that do not specify their own fields. Enums still show as pills." />

    <Checkbox
      value={displayInDefaultLists === true}
      size="22"
      label="Display in default lists"
      onChange={() => onDisplayInDefaultListsChange(!(displayInDefaultLists === true))}
    />

  </ModalField>

);

// Dev Tools
FieldDisplayInDefaultListsField.displayName = 'FieldDisplayInDefaultListsField';

export default FieldDisplayInDefaultListsField;
